import Pill from '../../../../Components/Dashboard/Pill';
import { formatThousands } from '../../../../Utils/dates/formatDate';
import styles from '../dashboardCards.module.css';

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const UpcomingList = ({ rows }) => (
    <ul className={styles.list} aria-label="Upcoming">
        {rows.map(row => {
            const d = new Date(row.workoutStart);
            return (
                <li key={row.id} className={styles.upRow}>
                    <div className={styles.dayTile} aria-hidden="true">
                        {DOW[d.getDay()]}
                        <b>{d.getDate()}</b>
                    </div>
                    <div>
                        <b style={{ fontWeight: 600 }}>{row.title || 'Workout'}</b>
                        <small>{row.volume != null ? `${formatThousands(row.volume)} m` : ''}</small>
                    </div>
                    <Pill tone="info">{row.status}</Pill>
                </li>
            );
        })}
    </ul>
);

export default UpcomingList;
